import { defineMessages } from 'react-intl';

export default defineMessages({
    title: {
        id: '_.funding_requirements.link_debit_card_title',
        defaultMessage: 'Link a debit card'
    },
    caption: {
        id: '_.funding_requirements.link_debit_card_caption',
        defaultMessage:
            'Your repayments will be taken automatically from your debit card.'
    },
    action: {
        id: '_.funding_requirements.link_debit_card_action',
        defaultMessage: 'Link card'
    },
    pending: {
        id: '_.funding_requirements.link_debit_card_action_pending',
        defaultMessage: 'Pending'
    }
});
